/* ─── Root wrapper ─── */

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-weight: 600;
  color: var(--md-on-surface-variant);
}

/* ─── Control (touch target) ─── */

.control {
  display: flex;
  align-items: center;
  padding-block: var(--space-6);
  padding-inline: 10px;
  cursor: pointer;
}

.control[data-disabled] {
  cursor: not-allowed;
  opacity: 0.38;
}

/* ─── Track ─── */

.track {
  position: relative;
  width: 100%;
  height: 4px;
  border-radius: var(--shape-full);
  background: var(--md-surface-container-highest);
}

/* ─── Indicator (filled portion) ─── */

.indicator {
  position: absolute;
  height: 100%;
  border-radius: inherit;
  background: var(--md-primary);
}

/* ─── Thumb ─── */

.thumb {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: var(--shape-full);
  background: var(--md-primary);
  box-shadow: var(--elevation-1);
  transition: box-shadow var(--motion-duration-short3);
}

.thumb::before {
  content: "";
  position: absolute;
  inset: -10px;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .thumb:hover {
    box-shadow: var(--elevation-2);
  }

  .thumb:hover::before {
    opacity: var(--state-hover);
  }
}

.thumb:has(:focus-visible) {
  --focus-ring-offset: var(--focus-ring-offset-outset);
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

.thumb:has(:focus-visible)::before {
  opacity: var(--state-focus);
}

.thumb:active::before {
  opacity: var(--state-pressed);
}

.control[data-disabled] .thumb::before {
  display: none;
}
